import { render, staticRenderFns } from "./otherOrderForm.vue?vue&type=template&id=a0b22cd0&scoped=true"
import script from "./otherOrderForm.vue?vue&type=script&lang=js"
export * from "./otherOrderForm.vue?vue&type=script&lang=js"
import style0 from "./otherOrderForm.vue?vue&type=style&index=0&id=a0b22cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b22cd0",
  null
  
)

export default component.exports